'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _radium = require('radium');

var _radium2 = _interopRequireDefault(_radium);

var _reactSyntaxHighlighter = require('react-syntax-highlighter');

var _reactSyntaxHighlighter2 = _interopRequireDefault(_reactSyntaxHighlighter);

var _styles = require('react-syntax-highlighter/dist/styles');

var _constants = require('./constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var Code = function Code(_ref, _ref2) {
  var children = _ref.children,
      language = _ref.language,
      props = _objectWithoutProperties(_ref, ['children', 'language']);

  var themeName = _ref2.themeName;
  return _react2.default.createElement(
    'div',
    _extends({
      className: _constants.CLASS_NAMES.CODE
    }, props),
    _react2.default.createElement(
      _reactSyntaxHighlighter2.default,
      {
        language: language,
        style: syntaxStyles[themeName],
        codeTagProps: codeStyles[themeName]
      },
      children
    )
  );
};

Code.contextTypes = {
  themeName: _react2.default.PropTypes.string
};

exports.default = (0, _radium2.default)(Code);


var codeStyles = {
  simple: {
    fontFamily: 'monospace',
    fontSize: '24px'
  },
  developer: {
    fontFamily: 'monospace',
    fontSize: '24px'
  }
};

var syntaxStyles = {
  simple: _styles.xcode,
  developer: _styles.xt256
};


/*****************
 ** WEBPACK FOOTER
 ** ../lib/Code.js
 ** module id = 125
 ** module chunks = 0
 **/